module.exports = __webpack_public_path__ + "img/value-intro-02.298e8872.jpg";